var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},_vm.$listeners),[_c('path',{attrs:{"d":"M15 7a1 1 0 112 0v18a1 1 0 11-2 0V7z"}}),_c('path',{attrs:{"d":"M7 17a1 1 0 110-2h18a1 1 0 110 2H7z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }